import { ParentSignupVerticalTypeId } from '../types';

// Server-authoritative vertical type ids. Keep in sync with
// `apps/angular/src/js/ng/common/constants/booking.constant.js typeIds` and
// with the backend enum.
export const bookingVerticalType = {
  CHILD_CARE: 1,
  PET_CARE: 2,
  SENIOR_CARE: 3,
  HOUSEHOLD_SERVICES: 4,
  DAY_CARE: 7,
  SITTERS_NANNIES_BACKUP_CARE: 8,
};

export const bookingVerticalFromSignupVertical = (
  parentSignupVerticalId: ParentSignupVerticalTypeId,
): number => {
  switch (parentSignupVerticalId) {
    case ParentSignupVerticalTypeId.PET_CARE_CAT:
    case ParentSignupVerticalTypeId.PET_CARE_DOG:
    case ParentSignupVerticalTypeId.PET_CARE_OTHER:
      return bookingVerticalType.PET_CARE;
    case ParentSignupVerticalTypeId.SENIOR_CARE:
      return bookingVerticalType.SENIOR_CARE;
    case ParentSignupVerticalTypeId.HOUSEHOLD_SERVICES:
      return bookingVerticalType.HOUSEHOLD_SERVICES;
    case ParentSignupVerticalTypeId.CHILD_CARE:
    default:
      return bookingVerticalType.CHILD_CARE;
  }
};

// Keep in sync with backend Booking.PaymentStatus and BookingUpdateConstants
export enum bookingPaymentStatusCode {
  PROCESSING_CHARGE = 'processing_charge',
  PROCESSING_DEPOSIT = 'processing_deposit',
  DEPOSIT_QUEUE = 'deposit_queue',
  DEPOSIT_COMPLETE = 'deposit_complete',
  DEPOSIT_FAILED_SOFT = 'deposit_failed_soft',
  CHARGE_FAILED_HARD = 'charge_failed_hard',
  DEPOSIT_FAILED_HARD = 'deposit_failed_hard',
  PARENT_CONFIRM_PAYMENT = 'parent_confirm_payment',
  SITTER_CONFIRMED = 'sitter_confirmed',
}

// Booking status codes that indicate a charge has been processed or is being processed.
// Checked against booking.status.code to disable payment method changes.
// Keep in sync with backend BookingUpdateConstants.chargedStatuses
export const chargedPaymentStatuses = new Set([
  bookingPaymentStatusCode.PROCESSING_CHARGE,
  bookingPaymentStatusCode.PROCESSING_DEPOSIT,
  bookingPaymentStatusCode.DEPOSIT_QUEUE,
  bookingPaymentStatusCode.DEPOSIT_COMPLETE,
  bookingPaymentStatusCode.DEPOSIT_FAILED_SOFT,
  bookingPaymentStatusCode.CHARGE_FAILED_HARD,
  bookingPaymentStatusCode.DEPOSIT_FAILED_HARD,
]);
